import { render, staticRenderFns } from "./DocumentUpload.vue?vue&type=template&id=5f9954f0&"
import script from "./DocumentUpload.vue?vue&type=script&lang=js&"
export * from "./DocumentUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f9954f0')) {
      api.createRecord('5f9954f0', component.options)
    } else {
      api.reload('5f9954f0', component.options)
    }
    module.hot.accept("./DocumentUpload.vue?vue&type=template&id=5f9954f0&", function () {
      api.rerender('5f9954f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/component/DocumentUpload.vue"
export default component.exports